<template lang="pug">
  v-container
    v-row(justify="center")
      v-col(cols="10")
        span Current editors
          v-chip.mx-1(v-for="e in sortedEditors")
            v-icon(small) {{ e.name === editingEditor ? 'mdi-pencil' : 'mdi-eye'}}
            | &nbsp;{{ e.name }}
    v-row(justify="center")
      v-col(cols="8")
        h1 {{ product.original_title }}
      v-col.text-right(cols="2")
        v-btn.info(:href="pageURL" target="_blank") Preview
    v-row(justify="center")
      v-col.py-0(cols="4")
        v-text-field(v-model="providerDisplay" label="Provider" readonly)
      v-col.py-0(cols="4" offset="2")
        v-row
          p.mt-5.ml-3.mr-12.title Rating
          v-rating.mt-4(v-model="product.rating" color="yellow" background-color="orange" half-increments)
      v-col.py-0(cols="4")
        v-select(v-model="product.vertical" :items="verticals" item-text="text" item-value="value" label="Vertical")
      v-col.py-0(cols="4" offset="2")
        v-select(v-model="product.city" :items="cities" item-text="name" item-value="id" label="City")
      v-col.py-0(cols="10")
        v-autocomplete(v-model="product.features" :items="features" item-text="text" item-value="id" label="Product Features" multiple chips)
          template(v-slot:selection="data")
            v-chip(v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeFeatures(data.item)")
              v-avatar(left)
                v-icon {{ data.item.icon }}
              |       {{ data.item.text }}
          template(v-slot:item="data")
            template(v-if="typeof data.item !== 'object'")
              v-list-item-content(v-text='data.item')
            template(v-else='')
              v-list-item-avatar
                v-icon {{ data.item.icon }}
              v-list-item-content
                v-list-item-title(v-html='data.item.text')
    v-row
      v-col.pt-0(cols="4" offset="1")
        v-select(label="Language" v-model="language" :items="locales" item-text="name" item-value="id")
      v-col.pt-0.px-1(cols="2")
        v-tooltip(top)
          template(v-slot:activator="{ on }")
            v-btn.mt-4.caption(icon v-on="on")
              v-icon mdi-translate
          span Add Language
        v-tooltip(top)
          template(v-slot:activator="{ on }")
            v-btn.mt-4.caption(icon v-on="on")
              v-icon mdi-trash-can-outline
          span Delete Language
      v-col.pt-0(cols="4")
        v-select(v-if="$store.state.groups.includes('Marketing')" label="Status" v-model="status" :items="statuses" item-text="text" item-value="value")
        v-select(v-if="$store.state.groups.includes('Production')" label="Phase" v-model="product.phase" :items="phases" item-text="text" item-value="value" :readonly="status === 'published'")
    v-row(justify="center")
      v-col.py-0(cols="10")
        v-tabs(v-model="tab" centered fixed-tabs background-color="darkred")
          v-tabs-slider(color="red")
          v-tab.white--text(href="#tabContent")
            v-icon mdi-table-of-contents
            | &nbsp; Content
          v-tab.white--text(href="#tabClazz" @click="refreshClazz = true")
            v-icon mdi-ticket
            | &nbsp; Class
          v-tab.white--text(href="#tabOption" @click="refreshOption = true")
            v-icon mdi-account-group-outline
            | &nbsp; Option
          v-tab.white--text(href="#tabMedia")
            v-icon mdi-folder-multiple-image
            | &nbsp; Media
        v-tabs-items.bg(v-model="tab")
          v-tab-item(value="tabContent")
            content-tab(:vertical="product.vertical" :language="language" :saveEnabled="saveEnabled" @save="saveProduct" @contentID="contentID = $event")
          v-tab-item(value="tabClazz")
            clazz-tab(:language="language" @save="saveProduct" :refresh="refreshClazz" :saveEnabled="saveEnabled" @afterRefresh="refreshClazz = $event")
          v-tab-item(value="tabOption")
            option-tab(:language="language" @save="saveProduct" :refresh="refreshOption" :saveEnabled="saveEnabled" @afterRefresh="refreshOption = $event")
          v-tab-item(value="tabMedia")
            media-tab(:card="product.card_image" :saveEnabled="saveEnabled")
</template>

<script>
import ContentTab from '@/components/ContentTab'
import ClazzTab from '@/components/ClazzTab'
import OptionTab from '@/components/OptionTab'
import MediaTab from '@/components/MediaTab'

export default {
  name: 'NewProduct',
  components: { ContentTab, ClazzTab, OptionTab, MediaTab },
  data: () => ({
    intervals: [],
    editors: [],
    tab: null,
    product: {},
    locales: [],
    language: 1,
    status: 'draft',
    slug: '',
    contentID: null,
    statuses: [
      { text: 'Draft', value: 'draft' },
      { text: 'Published', value: 'published' },
      { text: 'Inactive', value: 'inactive' }
    ],
    phases: [
      { text: 'Draft', value: 'draft' },
      { text: 'Final', value: 'final' }
    ],
    verticals: [
      { text: 'Joined Tour', value: 'JT' },
      { text: 'Private Tour', value: 'PT' },
      { text: 'Short Tour', value: 'ST' },
      { text: 'Tickets', value: 'TIX' },
      { text: 'Activities', value: 'XTVT' },
      { text: 'Transport', value: 'TPORT' },
      { text: 'VISA', value: 'VISA' },
      { text: 'Travel Products', value: 'TP' }
    ],
    cities: [],
    features: [],
    refreshClazz: false,
    refreshOption: false
  }),
  computed: {
    sortedEditors () {
      return Array.prototype.slice.call(this.editors).sort((a, b) => (a.first > b.first) ? 1 : -1)
    },
    editingEditor() {
      let oldest = null
      let oldestEditor = ''
      this.editors.forEach(e => {
        if (!oldest) {
          oldest = e.first
          oldestEditor = e.name
        } else if (e.first < oldest) {
          oldest = e.first
          oldestEditor = e.name
        }
      })
      return oldestEditor
    },
    providerDisplay () {
      return this.$options.filters.providerView(this.product.provider)
    },
    pageURL () {
      return process.env.VUE_APP_WEB_URL + '/' + this.slug + '/?preview=1'
    },
    saveEnabled () {
      // return  this.editingEditor === this.$store.state.username
      return true
    }
  },
  mounted () {
    const firstOpenOn = new Date()

    this.getCity()
    this.fetchProduct()
    this.fetchFeatures()
    this.fetchLocale()
    this.fetchStatus()

    const productId = this.$route.params.productID
    const topicId = `product:${productId}:edit`
    const publishInterval = setInterval(() => {
      this.$wamp.publish(topicId, [this.$store.state.username, firstOpenOn], {}, { exclude_me: false })
    }, 1000)
    this.intervals.push(publishInterval)

    const clearInterval = setInterval(() => {
      var i = this.editors.length
      while (i--) {
        const editor = this.editors[i]
        if ((new Date()) - editor.last > 1500) {
          this.editors.splice(i, 1);
        }
      }
    }, 1000)
    this.intervals.push(clearInterval)

    this.$wamp.subscribe(topicId, (args, kwArgs, details) => {
      const editor = args[0]
      const exists = this.editors.filter(e => e.name === editor).length > 0
      if (exists) {
        for (let i = 0; i < this.editors.length; i++) {
          let e = this.editors[i]
          if (e.name === editor) {
            e.last = new Date()
            e.first =  args[1]
            break
          }
        }
      } else {
        this.editors.push({ name: editor, last: new Date(), first: args[0] })
      }
    })
  },
  beforeDestroy () {
    this.intervals.forEach(i => {
      clearInterval(i)
    })
  },
  methods: {
    fetchProduct () {
      let id = this.$route.params.productID
      this.$axios.get(`/products/${id}/`)
        .then(resp => {
          this.product = resp.data
        })
    },
    fetchLocale () {
      let id = this.$route.params.productID
      this.$axios.get(`/contents/?product=${id}`)
        .then(resp => {
          resp.data.results.forEach(l => {
            this.locales.push(l.locale)
          })
        })
    },
    fetchStatus () {
      let id = this.$route.params.productID
      this.$axios.get(`/contents/?product=${id}&locale=${this.language}`)
        .then(resp => {
          this.status = resp.data.results[0].status
          this.slug = resp.data.results[0].slug
        })
    },
    getCity () {
      this.$axios.get('/cities/')
        .then(resp => {
          resp.data.results.forEach(c => {
            this.cities.push(c)
          })
        })
    },
    fetchFeatures () {
      this.$axios.get('/features/?type=product')
        .then(resp => {
          resp.data.results.forEach(f => {
            let feat = {}
            feat.id = f.id
            feat.icon = f.icon
            feat.text = f.featurelocales.filter(fl => fl.locale === this.language)[0].text
            this.features.push(feat)
          })
          // this.features = [...resp.data.results]
        })
    },
    removeFeatures (item) {
      const index = this.product.features.indexOf(item.id)
      if (index >= 0) this.product.features.splice(index, 1)
    },
    saveProduct () {
      let id = this.$route.params.productID
      let data = {
        rating: this.product.rating,
        vertical: this.product.vertical,
        city: this.product.city.id,
        features: this.product.features,
        phase: this.product.phase
      }
      this.$axios.patch(`/products/${id}/`, data)
        .then(resp => {
            // console.log(resp)
            this.saveStatus()
          })
          .catch(error => {
            console.log(error)
          })
    },
    saveStatus () {
      this.$axios.patch(`/contents/${this.contentID}/`, { status: this.status })
        .then(resp => {
            // console.log(resp)
          })
          .catch(error => {
            console.log(error)
          })
    }
  }
}
</script>

<style lang="scss" scoped>
.bg{
  background-color: #303030
}
</style>